/**
 * router path for a user's public profile (by nickname / username)
 * @param {{ nickname?: string | null } | null | undefined} user
 * @returns {string | null}
 */
export function userPublicProfilePath(user) {
  const raw = user?.nickname
  const nick =
    raw != null && String(raw).trim() !== '' ? String(raw).trim().replace(/^@/, '') : null
  return nick ? `/profile/${encodeURIComponent(nick)}` : null
}
